/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Audio_Extraction_CompleteInputs */



/**
* | output |
* | --- |
* | "Audio extraction completed successfully." |
*
* @param {Team_Project_Import_Audio_Extraction_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_audio_extraction_complete = /** @type {((inputs?: Team_Project_Import_Audio_Extraction_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Audio_Extraction_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraction audio terminée avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Audioextraktion wurde erfolgreich abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazione audio completata con successo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлечение аудиофайлов успешно завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extracción de audio completada exitosamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频提取成功。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ抽出が正常に完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो निष्कर्षण सफलतापूर्वक पूरा हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extração de áudio concluída com sucesso.")
	return /** @type {LocalizedString} */ ("Audio extraction completed successfully.")
});